module.exports = __webpack_public_path__ + "img/icon_title_5.74ccc344.svg";